import { regionForTimezone } from './regions';
import { luhn as luhnChecksumOk } from './countries/identity';
import { COUNTRY_PROFILES } from './countries';
function otherCountryDocument(country) {
    const code = (country ?? '').toUpperCase();
    if (code === 'SA' || code === 'PK' || !(code in COUNTRY_PROFILES))
        return null;
    const profile = COUNTRY_PROFILES[code];
    return profile.identity.documents.find((document) => document.type === profile.identity.defaultType) ?? null;
}
const SAUDI_LENGTH = 10;
const CNIC_LENGTH = 13;
export function nationalIdCountryOf(tenant) {
    if (tenant.country)
        return tenant.country.toUpperCase();
    return tenant.timezone ? (regionForTimezone(tenant.timezone)?.countryCode ?? null) : null;
}
export function usesSaudiIdentity(country) {
    return (country ?? '').toUpperCase() === 'SA';
}
export function nationalIdLabel(country) {
    const other = otherCountryDocument(country);
    if (other)
        return other.label;
    return usesSaudiIdentity(country) ? 'National ID / Iqama' : 'CNIC';
}
export function nationalIdHint(country) {
    const other = otherCountryDocument(country);
    if (other)
        return 'Or choose another document, a passport, or no document';
    return usesSaudiIdentity(country) ? '10 digits: 1 for a citizen, 2 for a resident' : '13 digits';
}
export function nationalIdPlaceholder(country) {
    const other = otherCountryDocument(country);
    if (other)
        return other.example;
    return usesSaudiIdentity(country) ? '1XXXXXXXXX or 2XXXXXXXXX' : '35201-1234567-1';
}
export function stripNationalId(raw) {
    return raw.replace(/[\s-]/g, '');
}
export function nationalIdKindOf(value) {
    if (/^1\d{9}$/.test(value))
        return 'saudi_national';
    if (/^2\d{9}$/.test(value))
        return 'iqama';
    if (/^\d{13}$/.test(value))
        return 'cnic';
    return 'other';
}
export function checkNationalId(country, raw) {
    const value = stripNationalId(raw);
    if (usesSaudiIdentity(country)) {
        if (!/^\d+$/.test(value) || value.length !== SAUDI_LENGTH) {
            return { ok: false, message: 'The national ID or Iqama number must be 10 digits' };
        }
        if (value[0] !== '1' && value[0] !== '2') {
            return { ok: false, message: 'A national ID starts with 1 and an Iqama number starts with 2' };
        }
        if (!luhnChecksumOk(value)) {
            return { ok: false, message: 'The last digit of this national ID or Iqama number does not match the others; check it against the card' };
        }
        return { ok: true, value, kind: nationalIdKindOf(value) };
    }
    if (!/^\d+$/.test(value) || value.length !== CNIC_LENGTH) {
        return { ok: false, message: 'CNIC must be 13 digits' };
    }
    return { ok: true, value, kind: 'cnic' };
}
//# sourceMappingURL=national-id.js.map